export default __webpack_public_path__ + "static/manBall-5331b212ba823bf21147d08034f37aa1.svg";